import { getAPIDomain } from "./config";
let regionCache = null;
let woredaCache = null;
export function logoutAndRedirect() {
  try {
    localStorage.removeItem("token");
    localStorage.clear();
  } catch (e) {
  }
  window.location.href = "/login";
}

export const login = async (email, password) => {
  try {
    const response = await fetch(`${getAPIDomain()}/api/users/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Login failed");
    }
    return data;
  } catch (error) {
    throw error;
  }
};
export const getGeoWoreda = async (selectedZone) => {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${getAPIDomain()}/api/geo/woreda?zone=${selectedZone}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      throw new Error(`Failed to fetch woredas: ${res.status}`);
    }
    const data = await res.json();
    const features = data.map((d) => ({
      type: "Feature",
      geometry: d.geometry,
      properties: {
        shapeName: d.woreda,
        ZONENAME: d.zone,
        REGIONNAME: d.regionalState,
        shapeArea: d.shapeArea,
        shapeLength: d.shapeLength
      },
    }));
    return features;
  } catch (err) {
    console.error("Error fetching woredas:", err);
  }
};

export async function getGeoRegionalState() {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${getAPIDomain()}/api/geo/regional-state`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Failed to fetch geo-regional-state: ${res.status}`);
      }
    }
    const data = await res.json();
    const features = data.map((d) => ({
      type: "Feature",
      geometry: d.geometry,
      properties: {
        shapeName: d.regionalState,
        shapeArea: d.shapeArea,
        shapeLength: d.shapeLength
      },
    }));
    return features;
  } catch (err) {
    console.error("Error fetching geo-woreda:", err);
    throw err;
  }
}
export async function getGeoZone(selectedRegionalState) {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${getAPIDomain()}/api/geo/zone?regionalState=${selectedRegionalState}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Failed to fetch geo-zone: ${res.status}`);
      }
    }
    const data = await res.json();
    const features = data.map((d) => ({
      type: "Feature",
      geometry: d.geometry,
      properties: {
        shapeName: d.zone,
        REGIONNAME: d.regionalState,
        shapeArea: d.shapeArea,
        shapeLength: d.shapeLength
      },
    }));
    return features;
  } catch (err) {
    console.error("Error fetching geo-woreda:", err);
    throw err;
  }
}
export async function getGeoKebele(selectedWoreda) {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${getAPIDomain()}/api/geo/kebele?woreda=${selectedWoreda}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Failed to fetch geo-kebele: ${res.status}`);
      }
    }
    const data = await res.json();
    const features = data.map((d) => ({
      type: "Feature",
      geometry: d.geometry,
      properties: {
        shapeName: d.kebele,
        WOREDANAME: d.woreda,
        ZONENAME: d.zone,
        REGIONNAME: d.regionalState,
        shapeArea: d.shapeArea,
        shapeLength: d.shapeLength
      },
    }));
    return features;
  } catch (err) {
    console.error("Error fetching geo-kebele:", err);
    throw err;
  }
}
const hotspotCache = {
  kebele: { data: null, timestamp: 0 },
  woreda: { data: null, timestamp: 0 },
  zone: { data: null, timestamp: 0 },
  regionalState: { data: null, timestamp: 0 },
  CACHE_DURATION: 5 * 60 * 1000,
};
export const clearHotspotCache = () => {
  hotspotCache.kebele.data = null;
  hotspotCache.woreda.data = null;
  hotspotCache.zone.data = null;
  hotspotCache.regionalState.data = null;
};

const fetchWithCache = async (endpoint, cacheKey) => {
  const now = Date.now();
  if (
    hotspotCache[cacheKey].data &&
    now - hotspotCache[cacheKey].timestamp < hotspotCache.CACHE_DURATION
  ) {
    return hotspotCache[cacheKey].data;
  }
  const token = localStorage.getItem("token");
  const response = await fetch(`${getAPIDomain()}/api/locations/${endpoint}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      logoutAndRedirect();
      throw new Error("Unauthorized");
    }
    throw new Error(`Failed to fetch ${endpoint}`);
  }
  const data = await response.json();
  hotspotCache[cacheKey] = {
    data,
    timestamp: now,
  };
  return data;
};

export const getHotSpotKebele = async () => {
  try {
    return await fetchWithCache("kebele", "kebele");
  } catch (error) {
    console.error("Error fetching kebele data:", error);
    throw error;
  }
};
export const getHotSpotWoreda = async () => {
  try {
    return await fetchWithCache("woreda", "woreda");
  } catch (error) {
    console.error("Error fetching woreda data:", error);
    throw error;
  }
};

export const getHotSpotZone = async () => {
  try {
    return await fetchWithCache("zone", "zone");
  } catch (error) {
    console.error("Error fetching zone data:", error);
    throw error;
  }
};

export const getHotSpotRegionalState = async () => {
  try {
    return await fetchWithCache("regional-state", "regionalState");
  } catch (error) {
    console.error("Error fetching regional state data:", error);
    throw error;
  }
};

export const invalidateHotspotCache = (type) => {
  if (hotspotCache[type]) {
    hotspotCache[type] = { data: null, timestamp: 0 };
  }
};

export async function getLocation(type) {
  try {
    const token = localStorage.getItem("token");

    const res = await fetch(`${getAPIDomain()}/api/locations/${type}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      }
      throw new Error(`Failed: ${res.status}`);
    }

    return await res.json();
  } catch (err) {
    console.error(`Error fetching ${type}`, err);
    throw err;
  }
}
export function getRegionalStates() {
  return getLocation("regional-state");
}

export function getZones() {
  return getLocation("zone");
}

export function getWoredas() {
  return getLocation("woreda");
}

export function getKebeles() {
  return getLocation("kebele");
}

export async function addParameter({ rowId, dbName, parameter }) {
  const token = localStorage.getItem("token");

  const res = await fetch(`${getAPIDomain()}/api/locations/parameters`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      rowId,
      dbName,
      parameter
    })
  });

  if (!res.ok) throw new Error("Failed to add water body");

  return await res.json();
}

export async function updateParameter({ rowId, dbName, newParameter, editIndex }) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/locations/parameters`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      rowId,
      dbName,
      editIndex,
      newParameter,
    })
  });

  if (!res.ok) throw new Error("Failed to update water body");

  return await res.json();
}

export async function updateEndemicity({ rowId, dbName, endemicity }) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/locations/endemicity`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      rowId,
      dbName,
      endemicity
    })
  });

  if (!res.ok) throw new Error("Failed to update water body");

  const data = await res.json();
  return { status: res.status, data };
}
export async function getGeoWoredaEndemicity(limit = 100, onBatchFetched) {
  const totalWoredas = 1000;
  const totalBatches = Math.ceil(totalWoredas / limit);

  for (let batch = 0; batch < totalBatches; batch++) {
    const offset = batch * limit;

    const res = await fetch(
      `${getAPIDomain()}/api/geo/woreda?limit=${limit}&offset=${offset}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    const data = await res.json();
    const features = data.map((d) => ({
      type: "Feature",
      geometry: d.geometry,
      properties: {
        WOREDANAME: d.woreda,
        ZONENAME: d.zone,
        REGIONNAME: d.regionalState,
        factors: {
          temperature_C: d?.parameters?.weather?.temperature_C ?? null,
          humidity: d?.parameters?.weather?.humidity ?? null,
          rainfall: d?.parameters?.rainfall ?? null,
          water_bodies:d?.parameters?.water_bodies ?? null,
          endemicity:d?.endemicity ??  null
        },
      },
    }));
    onBatchFetched(features, batch === totalBatches - 1);
  }
}
export async function getGeoRegionalStateEndemicity() {
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(
      `${getAPIDomain()}/api/geo/regional-state`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      if (res.status === 401 || res.status === 403) {
        logoutAndRedirect();
      } else {
        throw new Error(`Failed to fetch geo-regional-state: ${res.status}`);
      }
    }
    const data = await res.json();
    return data;
  } catch (err) {
    console.error("Error fetching geo-woreda:", err);
    throw err;
  }
}
// Woreda schistosomiasis risk predictions (schisto_risk_model_baseline.py output)
export async function getWoredaRiskPredictions() {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/risk-prediction/woreda`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    if (res.status === 401 || res.status === 403) {
      logoutAndRedirect();
    }
    throw new Error(`Failed to fetch risk predictions: ${res.status}`);
  }
  return await res.json();
}

// surveyed sites (Training Data.csv) with held-out predictions
export async function getSurveySites() {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/risk-prediction/sites`, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    if (res.status === 401 || res.status === 403) logoutAndRedirect();
    throw new Error(`Failed to fetch survey sites: ${res.status}`);
  }
  return await res.json();
}

// version, training date and held-out performance of the live model
export async function getRiskModelInfo() {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/risk-prediction/model-info`, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to fetch model info: ${res.status}`);
  return await res.json();
}

// Model Training page: verify predictions, train the separate feedback model
async function modelTrainingRequest(pathAndQuery, { method = "GET", body } = {}) {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/model-training${pathAndQuery}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 || res.status === 403) {
      logoutAndRedirect();
    }
    throw new Error(data.message || `Request failed: ${res.status}`);
  }
  return data;
}

// { view: unprocessed|processed|all, q, date: YYYY-MM-DD, page, limit }
export const getGeneratedRecords = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  ).toString();
  return modelTrainingRequest(`/records${qs ? `?${qs}` : ""}`);
};
// 20 random rows in the Training Data.csv layout, saved as sample_upload.csv
export async function downloadSampleCsv() {
  const token = localStorage.getItem("token");
  const res = await fetch(`${getAPIDomain()}/api/model-training/records/sample-csv`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    if (res.status === 401 || res.status === 403) logoutAndRedirect();
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || `Download failed: ${res.status}`);
  }
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement("a");
  a.href = url;
  a.download = "sample_upload.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// CSV in the Training Data.csv format -> predicted, added as processed records
export async function uploadRecordsCsv(file) {
  const token = localStorage.getItem("token");
  const body = new FormData();
  body.append("file", file);
  const res = await fetch(`${getAPIDomain()}/api/model-training/records/upload`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 || res.status === 403) logoutAndRedirect();
    const err = new Error(data.message || `Upload failed: ${res.status}`);
    err.details = data; // skipped rows / missing columns, when the API sends them
    throw err;
  }
  return data;
}
export const processAllGeneratedRecords = () =>
  modelTrainingRequest("/records/process-all", { method: "POST" });
export const deleteAllGeneratedRecords = () =>
  modelTrainingRequest("/records", { method: "DELETE" });
export const resetAllGeneratedRecords = () =>
  modelTrainingRequest("/records/reset-all", { method: "POST" });
export const createGeneratedRecords = (count) =>
  modelTrainingRequest("/records", { method: "POST", body: { count } });
// one Training Data.csv row, by its Sr No, added as an unprocessed record
export const addRecordBySrNo = (sr) =>
  modelTrainingRequest("/records", { method: "POST", body: { sr } });
export const processGeneratedRecord = (id, inputs) =>
  modelTrainingRequest(`/records/${id}/process`, { method: "POST", body: { inputs } });
// one record with every value typed in by hand: { inputs, name, woreda, lat, lon, real_prevalence_pct }
export const addManualRecord = (body) =>
  modelTrainingRequest("/records/manual", { method: "POST", body });
// fix a record's name, woreda and coordinates (inputs and result unchanged)
export const updateRecordLocation = (id, details) =>
  modelTrainingRequest(`/records/${id}/location`, { method: "PATCH", body: details });
// new unprocessed record with the same original values
export const duplicateGeneratedRecord = (id) =>
  modelTrainingRequest(`/records/${id}/duplicate`, { method: "POST" });
export const deleteGeneratedRecord = (id) =>
  modelTrainingRequest(`/records/${id}`, { method: "DELETE" });
export const predictTrainingRows = (rows) =>
  modelTrainingRequest("/predict", { method: "POST", body: { rows } });
export const getPredictionFeedback = () => modelTrainingRequest("/feedback");
export const savePredictionFeedback = (feedback) =>
  modelTrainingRequest("/feedback", { method: "POST", body: feedback });
export const deletePredictionFeedback = (id) =>
  modelTrainingRequest(`/feedback/${id}`, { method: "DELETE" });
export const getFeedbackModelStatus = () => modelTrainingRequest("/status");
export const getLevelRanges = () => modelTrainingRequest("/level-ranges");
